var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/social/solid/icon-facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,2 C22.1797017,2 28,7.83878488 28,15.041291 C28,21.7293325 22.9814775,27.2415122 16.5160746,27.9948438 L16.4711412,28 L16.4704403,18.6868682 L20.2599167,18.6868682 L20.8685792,15.0268732 L16.4968553,15.0268732 L16.4968553,12.3558376 C16.4968553,11.349973 16.8578616,10.7413826 18.2578616,10.7413826 L20.8685792,10.7413826 L20.8685792,7.36032485 C19.8828446,7.26182559 19.0728171,7.21385917 18.081761,7.2166299 C13.8641509,7.2166299 12.0327044,9.47348593 12.0327044,11.9247528 L12.0327044,15.0437785 L8.93333333,15.0437785 L8.93333333,18.7122262 L12.0327044,18.7122262 L12.0331327,27.7414186 C12.1526648,27.7694104 12.2728308,27.7957477 12.3936054,27.8204052 C6.46279365,26.6093948 2,21.3481689 2,15.041291 C2,7.83878488 7.82029825,2 15,2 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.4%",
    y: "-7.7%",
    width: "130.8%",
    height: "130.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/social/solid/icon-facebook",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.40920d0ab770d09f734b6058325673c7.svg";
export { ForwardRef as ReactComponent };